if (window.location.pathname.includes("admin/loss-types")) {
    window.app_methods.triggerSort();

    $(window).on("/api/admin/loss-types.success", (e, response, form) => {
        window.app_data.types = response.types;
        window.app_methods.reorder();
        window.app_methods.triggerSort();
    });
}



// WEBPACK FOOTER //
// ./resources/assets/js/pages/admin/loss_types.js